import styled from '@emotion/styled';
import {mixinFlexboxRow} from 'webapp-lib/styling';

export const NavigationGroup = styled.span`
  display: flex;
  height: 37px;
`;

export const StyledSubNavigationBar = styled.nav<{disabled?: boolean}>`
  border-top: 2px solid var(--color-core-primary);
  border-bottom: var(--regular-border-width) solid var(--color-core-primary);
  margin: 0;
  padding: 0;
  position: relative;
  user-select: none;
  ${mixinFlexboxRow}
  align-items: center;
  height: 40px;

  .SubNavLink {
    cursor: ${({disabled}): string => (disabled ? 'not-allowed' : 'pointer')};
    margin-left: 0;
  }
`;
